import { Controller } from '@hotwired/stimulus'

// Controller that parses a JSON string and filters the suggestions based on the input value.
// The suggestions are then displayed in a datalist element, which gives the effect of autocompleting your input.
export default class extends Controller {
  static values = {
    source: String,
  }

  connect() {
    this.initializeAutocomplete()
  }

  initializeAutocomplete() {
    // Listen for input events on the input field
    this.element.addEventListener('input', (event) => {
      const query = event.target.value.toLowerCase()

      // Remove dropdown if the input is empty
      if (query.trim() === '') {
        this.removeDropdown()
        return
      }

      const suggestions = JSON.parse(this.sourceValue).filter((item) =>
        item.toLowerCase().includes(query)
      )

      // Show the suggestions
      this.showSuggestions(suggestions)
    })

    // Remove dropdown when clicking outside the input field
    document.addEventListener('click', (event) => {
      if (
        !this.element.contains(event.target) &&
        !this.element.nextElementSibling?.contains(event.target)
      ) {
        this.removeDropdown()
      }
    })
  }

  showSuggestions(suggestions) {
    this.removeDropdown()

    // Create a new custom dropdown list
    const dropdown = document.createElement('ul')
    dropdown.classList.add('dropdown-menu', 'show')

    suggestions.slice(0, 10).forEach((suggestion) => {
      const option = document.createElement('button')
      option.classList.add('dropdown-item')
      option.type = 'button'
      option.textContent = suggestion

      option.addEventListener('click', () => {
        this.element.value = suggestion
        this.removeDropdown()
      })
      dropdown.appendChild(option)
    })

    this.element.insertAdjacentElement('afterend', dropdown)
  }

  removeDropdown() {
    const dropdown = this.element.nextElementSibling
    if (dropdown && dropdown.classList.contains('dropdown-menu')) {
      dropdown.remove()
    }
  }
}
